import { FormContextValues } from "react-hook-form";

import {
  FranchiseType,
  LearnerLessonType,
  Location,
  Maybe,
  ProductCategoryType,
  Proposition,
} from "@hubcapp/types";
import { Instructor, Salutation } from "@hubcapp/graphql";

export type Franchise = {
  id: string;
  name: string;
};

export type NewLearnerProps = Partial<
  Pick<
    FormContextValues<NewLearnerFormFields>,
    "errors" | "register" | "register" | "setValue" | "triggerValidation"
  >
> & {
  loading?: boolean;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  handleFirstNameClick: (event: any) => void;
  handleLastNameClick: (event: any) => void;
  handlePostcodeClick: (event: any) => void;
  handleMobileClick: (event: any) => void;
  handleEmailClick: (event: any) => void;
  handleDOBClick: (event: any) => void;
  handleSaveLearnerClick: (event: any) => void;
  onSalutationChange: (event: any) => void;
  onLessonChange: (event: any) => void;
  onAddressChange: (event: any) => void;
  onFranchiseChange: (event: any) => void;
  onLessonPriceChange: (price: string) => void;
  addresses?: Maybe<Location>[];
  franchiseId?: string;
  franchises?: Maybe<Franchise>[];
  selectedAddressId?: Maybe<string>;
  lessonType?: LearnerLessonType;
  lessonPrice?: string;
};

export type NewLearnerFormFields = {
  franchiseId: string;
  salutation: Salutation;
  firstName: string;
  lastName: string;
  pickupPostcode: string;
  address: string;
  mobileNumber: string;
  emailAddress: string;
  dateOfBirth: Date | null;
  lessonType?: LearnerLessonType;
  lessonPrice?: number;
};

export const lessonTypes = [
  LearnerLessonType.Standard,
  LearnerLessonType.Qualified,
  LearnerLessonType.PassPlus,
  LearnerLessonType.Motorway,
];

export type PropositionType = {
  id: string;
  proposition: Pick<Proposition, "brand" | "transmission" | "type">;
};

export type FranchiseOption = {
  id: string;
  name: string;
  type: FranchiseType;
};

export type InstructorPrices = {
  id: Instructor["id"];
  prices: {
    id: string;
    price: number;
    productCategory: ProductCategoryType;
  }[];
};

export type LessonPrices = {
  [P in LearnerLessonType]: number | null;
};
